import Base from "../base";
import axiosConfig from "../../services/Axios";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import Title from "../../components/ui/Title";
import BasketButton from "./BasketButton";
import ItemThumbs from "./ItemThumbs";
import ItemDescription from "../settings/items/Description";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";

function Item() {
  const { id } = useParams();
  const [item, setItem] = useState();
  const { t } = useTranslation();

  const getItem = async (id) => {
    await axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/shop/items/" + id)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setItem(response.data);
        }
      });
  };
  useEffect(() => {
    getItem(id);
  }, [id]);

  return (
    item && (
      <Base>
        <div className="mainContainer lg:grid lg:grid-cols-12">
          <div className="col-span-12 lg:col-span-3 text-center">
            <div className="bg-white p-4 rounded mb-6 shadow">
              <div className="relative h-96">
                <ItemThumbs item={item} height={96} />
              </div>
            </div>

            <div className="pt-4 text-center">
              <BasketButton item={item} className="justify-center" size="xl" />
            </div>
          </div>
          <div className="lg:ml-6 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9">
            <div className="flex mb-4 text-sm items-center">
              <FontAwesomeIcon
                icon={faChevronLeft}
                className="text-bioport-orange mr-3"
              />
              <NavLink
                to={"/"}
                className="border-b pb-1 border-gray-400 hover:border-bioport-blue"
              >
                {t("items.back")}
              </NavLink>
            </div>
            <div className="p-8 px-10 bg-white rounded-lg">
              <Title
                title={item.name}
                otherAction={
                  <div className="flex items-center text-bioport-orange-dark italic text-sm justify-center">
                    <span className="font-bold text-lg">
                      {item.currentAvailableQuantity}
                    </span>
                    <span className="text-sm font-normal ml-2">
                      {item.currentAvailableQuantity > 1
                        ? t("shop.availableQuantity_other")
                        : t("shop.availableQuantity_one")}
                    </span>
                  </div>
                }
              />
              <div className="text-sm">{item.description}</div>

              <div className="mt-12 font-bold text-lg">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className="text-bioport-orange mr-3"
                />
                {t("items.technicalInfos")} :
              </div>
              <ItemDescription item={item} />
            </div>
          </div>
        </div>
      </Base>
    )
  );
}
export default Item;
